"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Hooks = __importStar(require("preact/hooks"));
var styles_1 = require("@mui/material/styles");
var Box_1 = __importDefault(require("@mui/material/Box"));
var InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
var FormHelperText_1 = __importDefault(require("@mui/material/FormHelperText"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Button = __importStar(require("./A_Button"));
var TextField = __importStar(require("./A_InputField"));
var StyledHelperText = (0, styles_1.styled)(FormHelperText_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.palette.primary.main,
    });
});
/** Represents a URL in a textbox which will be copied when clicked */
var Component = function (p) {
    var _a = Hooks.useState(' '), helperText = _a[0], setHelperText = _a[1];
    var inputRef = Hooks.useRef(null);
    var onClick = function () {
        var _a;
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        setHelperText(p.helperText);
        p.copyToClipboard(p.linkToCopy);
    };
    return (Preact.h(Box_1.default, { display: "flex", flexDirection: "column" },
        Preact.h(TextField.Component, { type: 'text', value: p.linkToCopy, onClick: onClick, inputProps: {
                style: {
                    padding: '18px 12px',
                },
            }, InputProps: {
                readOnly: true,
                endAdornment: (Preact.h(InputAdornment_1.default, { position: "end" },
                    Preact.h(Button.Component, { "aria-label": "Copy link to clipboard", color: "secondary" },
                        Preact.h(Typography_1.default, { variant: "body1" }, p.ctaText)))),
            }, label: "", inputRef: inputRef }),
        Preact.h(StyledHelperText, null, helperText)));
};
exports.Component = Component;
